import { useId, useRef } from 'react';

import { ChipsProps, SelectProps, useValueTracker } from '@xemplo/base-multi-select';
import { V2Types } from '@xemplo/popover';
import { TagsSelectProps } from '@xemplo/stateful-list';

import { TagFieldProps } from '../tag-field.types';

export function useTagField(props: TagFieldProps) {
  const internalId = useId();
  const triggerId = `${internalId}${props.name}`;
  const listboxId = `${internalId}${props.name}-listbox`;
  const popoverRef = useRef<V2Types.PopoverRef>(null);
  const valueTracker = useValueTracker(props);

  const chipsProps = {
    value: valueTracker.valueListItems,
    disabled: props.disabled,
    readOnly: props.readOnly,
    onRemove: valueTracker.removeItem,
    onClear: valueTracker.clear,
  } satisfies ChipsProps;

  const selectProps = {
    ...props,
    triggerId,
    listboxId,
    hasValue: valueTracker.hasValue,
    value: valueTracker.internalValue,
    chipsProps,
  } satisfies Omit<SelectProps, 'open'>; // 'open' is provided by Popover.Trigger

  const listProps = {
    id: listboxId,
    items: props.items,
    onChange: valueTracker.handleChange,
    triggerId: triggerId,
    value: valueTracker.internalValue,
    onTagCreate: props.onTagCreate,
    onSearchChange: props.onSearchChange,
    searchPlaceholder: props.searchPlaceholder,
    maxTagChar: props.maxTagChar,
    validCharRegex: props.validCharRegex,
  } satisfies TagsSelectProps;

  return {
    ...props,
    triggerId,
    listboxId,
    popoverRef,
    selectProps,
    listProps,
    hasValue: valueTracker.hasValue,
    handleChange: valueTracker.handleChange,
  };
}
